export function createOneClickForm(postForm) {
  const fields = postForm.fields;
  // Original form should work without loading JS.
  // This changes the behavior and contents of post project form
  // to enable one-click functionality.

  function setJob(job) {
    fields.jobType = job.seo_url.toLowerCase();
    fields.title = `My ${job.name} Project`;
    fields.description = `I need ${job.context_phrase_worker}`;
    fields.skills = job.job_id;
  }

  return {
    setEmail: postForm.setEmail,
    setNewUserName: postForm.setNewUserName,
    setNewPassword: postForm.setNewPassword,
    setJob,
    setSubCategory: postForm.setSubCategory,
    setLocation: postForm.setLocation,
    submit: postForm.submit,
  };
}
